import { useEffect, useState } from "react";
import ZabanKharejiSingle from "./ZabanKharejiSingle";
import usePersistantState from "src/hooks/usePersistantState";

export default function ZabanKhareji({
  language,
  skills,
  setZabanKhareji,
  zabanKhareji,
}) {
  const [removeLanguage, setRemoveLanguage] = useState("");
  const zabanKharejiJSX = Object.keys(skills).map((skill, index) => (
    <ZabanKharejiSingle
      key={index}
      title={language}
      skill={skill}
      state={skills}
      handleState={setZabanKhareji}
      zabanKhareji={zabanKhareji}
    />
  ));
  useEffect(() => {
    if (!removeLanguage) return;
    const newObj = { ...zabanKhareji };
    delete newObj[removeLanguage];
    setZabanKhareji(newObj);
  }, [removeLanguage]);
  return (
    <>
      <div className="flex flex-row items-center border border-solid border-gray-300 my-4 rounded-md pl-4">
        {language !== "انگلیسی" && (
          <span
            className="-mt-32 mr-2 cursor-pointer"
            onClick={() => {
              setRemoveLanguage(language);
            }}
          >
            <img src={"assets/img/close-circle-rose-400.svg"} />
          </span>
        )}
        <h5 className="px-2 w-1/6">{language}</h5>
        <div className="border-r w-5/6">{zabanKharejiJSX}</div>
      </div>
    </>
  );
}
